import React from "react";
import { FiCheckCircle as CheckCircle, FiXCircle as XCircle, FiStar as Star } from "react-icons/fi";
import { Link } from "react-router-dom";
import { LoungeParticipant } from "src/features/lounge/types";

type ParticipantCardProps = {
  title: string;
  user: (LoungeParticipant & { isSelected?: boolean }) | null;
  isInitiator?: boolean;
};

export const ParticipantCard: React.FC<ParticipantCardProps> = ({ title, user, isInitiator }) => {
  const { id, name, role, pictureURL, isSelected = false } = user ?? {};

  const ParticipantInfo = () => {
    return (
      <>
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <h4 className="text-sm font-bold text-gray-900">{title}</h4>
            {title === "Initiator" && <Star className="w-4 h-4 text-amber-500" />}
          </div>
          {!isInitiator && (
            <span
              className={`inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-full transition-all duration-300 ${
                isSelected
                  ? "bg-emerald-100 text-emerald-700 ring-2 ring-emerald-200 shadow-sm"
                  : "bg-gray-100 text-gray-600 ring-2 ring-gray-200"
              }`}
            >
              {isSelected ? <CheckCircle className="w-3.5 h-3.5" /> : <XCircle className="w-3.5 h-3.5" />}
              {isSelected ? "Selected" : "Not Selected"}
            </span>
          )}
        </div>

        <div className="flex items-start gap-4">
          <div className="relative">
            <img
              src={pictureURL ?? "/deleted-user.png"}
              alt={name ?? "Deleted User"}
              className="w-14 h-14 rounded-2xl object-cover ring-3 ring-white shadow-lg transition-transform duration-300 group-hover:scale-110"
            />
          </div>

          <div className="flex-1 min-w-0">
            <p className="text-base font-bold text-gray-900 truncate mb-1">{name ?? "Unknown User"}</p>
            <p className="text-sm text-gray-600 truncate mb-2">{role}</p>
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="group relative bg-white rounded-2xl border border-gray-200 overflow-hidden transition-all duration-300 hover:shadow-xl hover:border-blue-300 cursor-pointer">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50/50 to-purple-50/50 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

      {user ? (
        <Link className="relative p-6 no-underline block" to={"/users/" + id}>
          <ParticipantInfo />
        </Link>
      ) : (
        <div className="relative p-6 no-underline block">
          <ParticipantInfo />
        </div>
      )}
    </div>
  );
};
